module.exports = __webpack_public_path__ + "static/media/illustration-b@2x.10be2e99.png";